<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#182444"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#182444" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 sm9 md10 text-center text-md-left>
        <span class="mainHeader">ELECTION TYPE</span>
      </v-flex>
      <!-------------------------ADD CUSTOMER TO SCHEME----------------------------->
      <v-flex xs12 sm3 md2 class="buttons1" pt-2 pt-sm-0 text-center text-md-right>
        <v-btn dark color="#182444" @click="adddialog = true" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add New
        </v-btn>
      </v-flex>
       <!-------------------------LIST OF CUSTOMER IN SCHEME----------------------------->
      <v-flex xs12 py-6 text-left>
        <v-card
          class="rounded-lg"
          elevation="0"
          :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'"
          :flat="$route.name == 'Dashboard' ? true : false"
        >
          <v-layout wrap pa-4 v-if="electionList">
            <v-flex xs12 v-if="electionList.length > 0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont"><b>S.No.</b></th>
                      <th class="text-left tablefont"><b>Name</b></th>
                      <th class="text-left tablefont"><b>From year</b></th>
                      <th class="text-left tablefont">
                        <b>To year</b>
                      </th>
                      <th class="text-left tablefont"><b>Action</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in electionList" :key="i" class="table">
                      <!-- <td>{{ i + 1 }}</td> -->
                      <td>
                        <span v-if="page == 1">
                          {{ i + 1 }}
                        </span>
                        <span v-else>
                          {{ i + 1 + 20 * (page - 1) }}
                        </span>
                      </td>
                      <td>
                        <span v-if="value.name">{{
                          value.name
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.from">{{
                          value.from
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.to">{{
                          value.to
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td class="text-center">
                         <v-layout wrap>
                          <v-flex xs6>
                            <v-icon
                            size="18"
                            color="#182444"
                            style="cursor: pointer"
                            @click="(deletedialog = true), (DeleteId = value._id)"
                            >mdi-delete</v-icon
                          >
                          </v-flex>
                          <v-flex xs6>
                            <v-icon
                          size="18"
                          color="#182444"
                          style="cursor: pointer"
                          @click="(dialogedit = true), (editItem = value)"
                          >mdi-pencil</v-icon
                        >
                          </v-flex>
                         </v-layout>
                        </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
            <v-flex xs12 v-else pa-4 text-center class="tablefont1"> No data found </v-flex>
          </v-layout>
        </v-card>
        <v-layout wrap v-if="electionList">
          <v-flex xs12 pt-4 v-if="electionList.length > 0">
            <v-pagination
              small
              color="#182444"
              v-model="page"
              :length="Pagelength"
            >
            </v-pagination>
          </v-flex>
        </v-layout>
        <v-dialog width="400px" v-model="deletedialog">
            <v-card width="400px" class="pa-2">
             
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Delete</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                  @click="deletedialog = false"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-card-text class="pa-4"
                >Are you sure you want to delete this election type?
              </v-card-text>
              <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <!-- <v-btn
                  color="grey"
                  text
                  class="button1"
                  @click="deletedialog = false"
                  >Cancel</v-btn
                > -->
                <v-btn
                  color="#182444"
                  class="button1"
                  dark
                  @click="deleteElection(DeleteId)"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
      <!-------------------------ADD CUSTOMER TO SCHEME DIALOG----------------------------->
        <v-dialog width="500px" v-model="adddialog">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="500px" class="rounded-lg">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Add Election Type</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(adddialog = false)(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Election Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                          :rules="[rules.required]"
                    outlined
                    hide-details
                    dense
                    color="#50659f"
                    v-model="electionName"
                    :items="electionNames"
                    label="Choose election"
                  ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">From Year</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                    outlined
                    hide-details
                    dense
                    color="#50659f"
                    v-model="fromYear"
                    :items="yearsArray"
                    label="Enter starting year"
                  ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">To Year</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                    outlined
                    hide-details
                    dense
                    color="#50659f"
                    v-model="toYear"
                    :items="yearsArray"
                    label="Enter ending year"
                  ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs12 md3 text-center text-md-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddElection()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="500px" v-model="dialogedit">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="500px" class="px-4 py-4 rounded-lg">
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Edit Election</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(dialogedit = false)(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter election name"
                            v-model="editItem.name"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">From Date</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                    outlined
                    hide-details
                    dense
                    color="#50659f"
                    v-model="editItem.from"
                    :items="yearsArray"
                    label="Enter starting year"
                  ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">To year</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                    outlined
                    hide-details
                    dense
                    color="#50659f"
                    v-model="editItem.to"
                    :items="yearsArray"
                    label="Enter ending year"
                  ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="editElection()"
                        ><v-icon>mdi-pencil</v-icon>Edit</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      yearsArray: [],
      showsnackbar: false,
      timeout: 2000,
      deletedialog: false,
      DeleteId: null,
      addcat: false,
      editItem: {},
      ServerError: false,
      appLoading: false,
      electionList: [],
      electionNames:["State Legislative Assembly","LokSabha Election","Dist.Panchayat Election","Block Panchayat Election","GramaPanchayat Election"],
      toYear: null,
      electionName: null,
      fromYear: null,
      page: 1,
      // page: 0,
      currentPage: 1,
      adddialog: false,
      dialogedit: false,
      //   curItem: {},
      msg: null,

      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      curItem: {
        gstSlab2Percentage: 0,
        gstSlab2MinimumPrice: 0,
      },
    };
  },

  watch: {
    currentPage() {
      this.getData();
    },
  },

  mounted() {
    this.getData();
    this.generateYearsArray();
  },

  methods: {
    resetForm() {
      this.$refs.addcat.reset();
    },
    generateYearsArray() {
      const currentYear = new Date().getFullYear();
      const yearsBack = 5;
      const yearsForward = 20;

      const startYear = currentYear - yearsBack;
      const endYear = currentYear + yearsForward;

      this.yearsArray = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
      console.log(this.yearsArray)
    },
    deleteElection(id) {
      axios({
        url: "/electiontype/remove",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.deletedialog = false;
            this.DeleteId = 0;
            this.appLoading = false;
            this.getData();
          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
            this.deletedialog = false;
            this.getData();
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    AddElection() {
      this.appLoading = true;
      axios({
        url: "/electiontype/add",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          from: this.fromYear,
          name: this.electionName,
          to: this.toYear,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.adddialog = false;
          this.toYear = null;
          this.electionName = null;
          this.fromYear = null;
          this.$refs.addcat.reset();
          this.msg = response.data.msg;
            this.showsnackbar = true;
          this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          this.$refs.addcat.reset();
          this.adddialog = false;
          this.getData();

          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/electiontype/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
          searchKeyword: "",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.electionList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    editElection() {
      axios({
        url: "/electiontype/edit",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editItem._id,
          from: this.editItem.from,
          name: this.editItem.name,
          to: this.editItem.to,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.dialogedit = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.appLoading = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.deletedialog = false;
            this.getData();
          }

        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
  <style scoped>
.v-text-field input {
  font-family: kumbhBold;
}
</style>
  